import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { TopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { PURCHASE_ORDERS_LIST_CONTROLS_VIEW } from "@constants/storage"

import PurchaseOrderCardView from "./views/PurchaseOrderCardView/PurchaseOrderCardView"
import PurchaseOrderTableView from "./views/PurchaseOrderTableView/PurchaseOrderTableView"

export default function PurchaseOrderList() {
    const [createRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.CREATE])

    return (
        <AppFrame.Root pageId="PurchaseOrderList">
            <ViewTypesProvider viewTypeKey={PURCHASE_ORDERS_LIST_CONTROLS_VIEW} defaultViewType="table">
                {({ activeViewType }) => (
                    <>
                        <TopBar.Root>
                            <TopBar.Header>
                                <TopBar.TopBarHeaderStart>
                                    <TopBar.PageTitle
                                        label={objectMap.purchase_order.labelPlural}
                                        icon={objectMap.purchase_order.iconActive}
                                    />
                                </TopBar.TopBarHeaderStart>
                                <TopBar.TopBarHeaderEnd>
                                    <TopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            purchase_orders_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                purchase_orders_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <TopBar.SearchButton scope="Purchase Orders" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <TopBar.ViewSelector viewTypes={["table", "card"]} />
                                    <AccessCheck
                                        permissions={{
                                            purchase_orders_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <TopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </TopBar.TopBarHeaderEnd>
                            </TopBar.Header>
                        </TopBar.Root>
                        {activeViewType === "card" ? <PurchaseOrderCardView /> : <PurchaseOrderTableView />}
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
